// src/pages/ClientEdit.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiRequest } from "../api";

const inputStyle = {
  width: "100%",
  background: "#0f2235",
  color: "#ffffff",
  border: "1px solid rgba(255,255,255,0.10)",
  borderRadius: 10,
  padding: 12,
  boxSizing: "border-box",
};

export default function ClientEdit() {
  const { clientId } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    company_name: "",
    contact_name: "",
    email: "",
    phone: "",
    address: "",
    notes: "",
    archived: false,
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadClient() {
      setLoading(true);
      setError("");

      try {
        const client = await apiRequest(`/clients/${clientId}`);
        setForm({
          company_name: client.company_name || "",
          contact_name: client.contact_name || "",
          email: client.email || "",
          phone: client.phone || "",
          address: client.address || "",
          notes: client.notes || "",
          archived: Boolean(client.archived),
        });
      } catch (err) {
        setError(err.message || "Failed to load client.");
      } finally {
        setLoading(false);
      }
    }

    loadClient();
  }, [clientId]);

  function updateField(name, value) {
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  async function saveClient(e) {
    e.preventDefault();
    setSaving(true);
    setError("");

    try {
      await apiRequest(`/clients/${clientId}`, {
        method: "PUT",
        body: form,
      });

      navigate(`/clients/${clientId}`);
    } catch (err) {
      setError(err.message || "Failed to save client.");
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return (
      <div className="app-container">
        <div style={{ maxWidth: 900, margin: "0 auto", padding: 24 }}>
          Loading client...
        </div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <div style={{ maxWidth: 900, margin: "0 auto", padding: 24 }}>
        <button onClick={() => navigate(`/clients/${clientId}`)}>← Back</button>

        <h2 style={{ marginTop: 16 }}>Edit Client</h2>

        {error && (
          <div
            className="card"
            style={{
              marginBottom: 20,
              background: "rgba(120,0,0,0.25)",
              border: "1px solid rgba(255,80,80,0.35)",
              color: "#ffd2d2",
            }}
          >
            {error}
          </div>
        )}

        <form
          onSubmit={saveClient}
          className="card"
          style={{
            border: "1px solid rgba(255,255,255,0.10)",
            borderRadius: 16,
            padding: 20,
          }}
        >
          <div style={{ display: "grid", gap: 14 }}>
            <label>
              Company Name
              <input
                style={inputStyle}
                value={form.company_name}
                onChange={(e) => updateField("company_name", e.target.value)}
              />
            </label>

            <label>
              Contact Name
              <input
                style={inputStyle}
                value={form.contact_name}
                onChange={(e) => updateField("contact_name", e.target.value)}
              />
            </label>

            <label>
              Email
              <input
                style={inputStyle}
                value={form.email}
                onChange={(e) => updateField("email", e.target.value)}
              />
            </label>

            <label>
              Phone
              <input
                style={inputStyle}
                value={form.phone}
                onChange={(e) => updateField("phone", e.target.value)}
              />
            </label>

            <label>
              Address
              <textarea
                rows={4}
                style={inputStyle}
                value={form.address}
                onChange={(e) => updateField("address", e.target.value)}
              />
            </label>

            <label>
              Notes
              <textarea
                rows={4}
                style={inputStyle}
                value={form.notes}
                onChange={(e) => updateField("notes", e.target.value)}
              />
            </label>

            <button
              type="submit"
              disabled={saving}
              style={{
                background: "#f5c542",
                color: "#0b1622",
                border: "none",
                borderRadius: 10,
                padding: "10px 16px",
                fontWeight: 700,
                cursor: saving ? "default" : "pointer",
                opacity: saving ? 0.7 : 1,
                width: "fit-content",
              }}
            >
              {saving ? "Saving..." : "Save Client"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
